/**
 * Определяет значения возможных направлений навигации внутри формы
 * Их, что логично, 2: можно перейти к следующему (+n) и к предыдущему (-n) вопросу.
 *  */
export var EFormNavigationDirections;

(function (EFormNavigationDirections) {
  EFormNavigationDirections["Backward"] = "backward";
  EFormNavigationDirections["Forward"] = "forward";
})(EFormNavigationDirections || (EFormNavigationDirections = {}));